import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import locales from "../locales";

const { defaultLanguage } = locales;
// const defaultLanguage = locales.defaultLanguage;
const languages = _.map(locales.languages, (language) => language.key);

export default () => (Component) => {
  class MultiLanguage extends React.PureComponent {
    static contextTypes = {
      store: PropTypes.object,
    };

    state = {
      language: defaultLanguage,
    };

    componentDidMount = () => {
      this.init();
    };

    componentWillReceiveProps() {
      this.init();
    }

    init = () => {
      if (this.context.store) {
        const { getState, subscribe } = this.context.store;
        subscribe(() => this.switchLanguage(getState().language.currentActive));
        this.switchLanguage(getState().language.currentActive);
      }
    };

    getLangData = (language) => {
      // console.log("getLangData", {
      //   language,
      //   locales,
      //   data: _.find(locales.languages, { key: language }),
      // });
      // const langData = _.find(locales.languages, { key: language }).data;
      const data = _.find(locales.languages, { key: language });
      const langData = _.get(data, "data");
      return langData;
    };

    getAnyLanguage = (content) => {
      let result = content;
      for (let index = 0; index < languages.length; index += 1) {
        const language = languages[index];
        // console.log("getLangData-getAnyLanguage", language);
        const langData = this.getLangData(language);
        const contentLang = _.get(langData, content);
        if (contentLang) {
          result = contentLang;
          break;
        }
      }
      return result;
    };

    getDefaultLanguage = (content) => {
      // console.log("getLangData-getDefaultLanguage", defaultLanguage);
      const langData = this.getLangData(defaultLanguage);
      const contentLang = _.get(langData, content);
      if (!contentLang) return this.getAnyLanguage(content);
      return contentLang;
    };

    getDataFromString = (content) => {
      const { language } = this.state;
      // console.log("getLangData-getDataFromString", language);
      const langData = this.getLangData(language);
      // const langData = this.getLangData("en");
      const contentLang = _.get(langData, content);
      if (!contentLang) return this.getDefaultLanguage(content);
      return contentLang;
    };

    getDataFromObject = (object) => {
      const { language } = this.state;
      return _.get(object, language, _.get(object, defaultLanguage));
    };

    getDataWithLanguage = (content) => {
      if (_.isEmpty(content)) return "";
      let string = "";
      if (_.isObject(content)) {
        string = this.getDataFromObject(content);
      } else {
        string = this.getDataFromString(content);
      }
      return string;
    };

    switchLanguage = (language) => {
      // console.log("switchLanguage", language);
      if (this.state.language !== "language") {
        this.setState({
          language,
        });
      }
    };

    render() {
      const { forwardedRef, ...rest } = this.props;
      return (
        <Component
          ref={forwardedRef}
          {...rest}
          languages={locales.languages}
          currentLanguage={this.state.language}
          t={this.getDataWithLanguage}
        />
      );
    }
  }

  return React.forwardRef((props, ref) => {
    return <MultiLanguage {...props} forwardedRef={ref} />;
  });
};



// WEBPACK FOOTER //
// ./src/hoc/multiLanguage.js